import { useQuery } from "@tanstack/react-query";
import { useTonAddress } from "@tonconnect/ui-react";
import { useParams } from "react-router-dom";
import { Address } from "ton-core";
import { Dao } from "../wrappers/Dao";
import { JettonWallet } from "../wrappers/JettonWallet";
import { getTonClient } from "./tonClient";

export const getSeqno = async (owner: string) => {
  const tonClient = await getTonClient();
  const result = await tonClient.runMethod(Address.parse(owner), "seqno", []);
  return result.stack.readNumber();
};

export const waitWalletUpdate = async (owner: string, seqno: number) => {
  await new Promise((resolve) => setTimeout(resolve, 6000));

  for (let i = 0; i < 5; i++) {
    const nextSeqno = await getSeqno(owner).catch(() => 0);
    if (nextSeqno > seqno) {
      return;
    } else {
      await new Promise((resolve) => setTimeout(resolve, 2000));
    }
  }
};

export const useWalletData = () => {
  const { address } = useParams();
  const owner = useTonAddress(false);

  return useQuery(
    [owner, "wallet"],
    async () => {
      const tonClient = await getTonClient();

      const dao = tonClient.open(
        Dao.createFromAddress(Address.parse(address!))
      );

      const jettonAddress = await dao.getWalletAddress(Address.parse(owner!));

      const wallet = tonClient.open(
        JettonWallet.createFromAddress(jettonAddress)
      );

      return await wallet.getDaoWalletDate();
    },
    { enabled: owner != null && address != null }
  );
};
